<!--suppress HtmlUnknownAnchorTarget -->
<template>
  <footer
    v-show="total"
    class="footer"
  >
    <span class="todo-count">
      <strong>{{ remaining }}</strong>
      {{ remaining | pluralize }} left
    </span>
    <ul class="filters">
      <li>
        <a
          href="#/all"
          :class="{ selected: visibility === 'all' }"
        >
          All
        </a>
      </li>
      <li>
        <a
          href="#/active"
          :class="{ selected: visibility === 'active' }"
        >
          Active
        </a>
      </li>
      <li>
        <a
          href="#/completed"
          :class="{ selected: visibility === 'completed' }"
        >
          Completed
        </a>
      </li>
    </ul>
    <button
      v-show="total > remaining"
      class="clear-completed"
      @click="clearCompleted"
    >
      Clear completed
    </button>
  </footer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  filters: {
    pluralize(n) {
      return n === 1 ? "item" : "items";
    }
  },
  computed: {
    ...mapGetters("todoList", ["remaining", "todos", "visibility"]),
    total() {
      return this.todos.length;
    }
  },
  methods: {
    ...mapActions("todoList", ["clearCompleted"])
  }
};
</script>
